// extracted by mini-css-extract-plugin
module.exports = {"highlight":"ModuleTitle_highlight__3QNFx","titleContainer":"ModuleTitle_titleContainer__3qpXB","iconContainer":"ModuleTitle_iconContainer__U-XxW"};